import React, { useState } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { SortIcon, Wrapper } from './styles';

interface Props {
    children: React.ReactNode;
    onClick?: () => void;
}

export const SortToggle = ({ children, onClick }: Props) => {
    const [sort, setSort] = useState<'asc' | 'desc' | null>(null);

    const finalOnClick = () => {
        if (onClick) {
            onClick();
        } else {
            setSort((prevSort) => {
                if (prevSort === null) {
                    return 'desc';
                } else if (prevSort === 'desc') {
                    return 'asc';
                } else {
                    return null;
                }
            });
        }
    };

    return (
        <Wrapper onClick={finalOnClick}>
            {children}
            <AnimatePresence initial={false}>
                {sort && (
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                        <SortIcon $sort={sort} />
                    </motion.div>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};
